var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"color":"#828282"}},[_vm._t("prefix"),_vm._v(" "+_vm._s(_vm.displayHours)+" : "+_vm._s(_vm.displayMinutes)+" : "+_vm._s(_vm.displaySeconds)+"\n  ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }